import { APP_BASE_HREF } from '@angular/common';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppSettings, AvailableDrupalVersions, BootstrapVersion, DrupalVersion, INDIVIDUAL } from 'pac-api';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

try {
  const appSettings = fetch('/api/appSettings?wizard=1', {
    credentials: 'omit',
  });

  const user = fetch('/api/individual', {
    credentials: 'same-origin',
  });

  Promise.all([appSettings, user])
    .then(([appSettings, user]) => Promise.all([appSettings.json(), user.json()]))
    .then(([appSettings, user]) => {
      const drupal: AvailableDrupalVersions = appSettings.drupal;

      return platformBrowserDynamic([
        {
          provide: AppSettings,
          useValue: appSettings,
        },
        {
          provide: INDIVIDUAL,
          useValue: user,
        },
        {
          provide: APP_BASE_HREF,
          useValue: '/',
        },
        {
          provide: DrupalVersion,
          useValue: drupal,
        },
        {
          provide: BootstrapVersion,
          useValue: drupal == 'd7' ? 'bs3' : 'bs5',
        }
      ])
        .bootstrapModule(AppModule);
    })
    .catch((error) => {
      console.log(error);

      if (environment.production) {
        if (window.location.search.indexOf('error=') === -1) {
          window.location.href = '/signup?error=' + encodeURIComponent(error);
        }
      }
    });
} catch (error) {
  console.log(error);

  if (environment.production) {
    if (window.location.search.indexOf('error=') === -1) {
      window.location.href = '/signup?error=' + encodeURIComponent(error);
    }
  }
}
